import { View } from "@gluestack-ui/themed";
import { IconNames, IIcon } from "@repo/core/components/core/Icon/types";

export enum HeaderStyleEnum {
  default = "default",
  dark = "dark",
  light = "light",
  grey = "grey",
  transparent = "transparent",
  primary = "primary"
}
type UIViewProps = React.ComponentProps<typeof View>;

export interface CustomHeaderProps {
  title: string;
  onBackPress?: () => void;
  showBackButtonOnWeb?: boolean;
  rightIcon?: IconNames;
  rightIconVariant?: IIcon["variant"];
  rightWebLabel?: string;
  rightIconSize?: number;
  headerStyle?: HeaderStyleEnum;
  bg?: UIViewProps["bg"];
  onPressRightIcon?: () => void;
  mb?: UIViewProps["mb"];
  headerMarginBottom?: UIViewProps["mb"];
}
